import styled from "styled-components";
import { Button, InputCopy, ModalDefault, Notice } from "@ficatranquilo/contabilidade.com-ui";

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

/**
 * Mostra a chave recém-gerada, a única vez em que o texto dela existe na tela.
 * Só fecha pelo botão ou pelo X: um clique fora ou o Esc perderiam a chave.
 */
export default function ApiKeySecretModal({ plaintext, onClose }) {
  return (
    <ModalDefault
      $showModal
      $setShowModal={onClose}
      $noClose
      $size="medium"
      $title="Chave gerada"
      $contentBackground="N0"
      $footer={<Button $text="Fechar" $variant="primary" $action={onClose} $noWidth />}
    >
      <Stack>
        <Notice
          $variant="orange"
          $text="Esta é a única vez que esta chave será exibida. Copie e guarde em local seguro: não conseguiremos exibi-la novamente."
        />
        <InputCopy $label="Chave de API" defaultValue={plaintext} $textCopy="Copiar chave" $textCopied="Chave copiada!" />
      </Stack>
    </ModalDefault>
  );
}
